import React from 'react'

import Myorders from './Myorders'

const MyorderOne = () => {
  return (
    <>
     <div>
        <Myorders/>
     </div>
    </>
  )
}

export default MyorderOne